import React from 'react';
import MentorEditForm, { REQUIRED_CHOICE, REQUIRED_COMMENT, YES_NO_NA_OPTIONS } from '../MentorEditForm';

// Mirrors the field set of CreateObservationRss. Keep the two in step.
const CHOICE_LABELS = {
    eye_contact: 'Acknowledged individual and made eye contact?',
    can_help: 'Asked, “How can I help you?”',
    introduced: 'Introduced self by name and role?',
    explained: 'Explained documents/process and/or answered questions?',
    what_else: 'Asked, “What else can I help you with today?”',
    thank_you: '“Thank you for choosing Summa.”',
    cell_use: 'Avoided cell phone use?',
    dress_code: 'Followed dress code?',
    protected_phi: 'Protected PHI?',
    followed_script: 'Followed appropriate POS cash collection script?',
};

const FIELDS = [
    ...Object.entries(CHOICE_LABELS).map(([name, label]) => ({
        name,
        label,
        input: 'select',
        options: YES_NO_NA_OPTIONS,
        rules: REQUIRED_CHOICE
    })),
    { name: 'comments', label: 'Comments', input: 'textarea', rules: REQUIRED_COMMENT },
];

export default function EditObservationRss({ employee, mentor, onSaved }) {
    return (
        <MentorEditForm
            title='Edit Observation - RRS'
            employee={employee}
            mentor={mentor}
            fields={FIELDS}
            onSaved={onSaved}
        />
    )
}
